module.exports = __webpack_public_path__ + "media/mascot/mascot5-e4eef838.png";